var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup82(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 55,
    height: 60,
    viewBox: "0 0 55 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.43983 58.8872C0.865323 58.107 0.495177 57.1756 0.496095 56.0638C0.513546 38.6564 0.50528 21.2485 0.534671 3.84067C0.53559 3.13482 0.818481 2.41979 1.03019 1.72726C1.17531 1.25241 1.51285 1.18168 1.89861 1.52014C2.50297 2.0501 3.13625 2.55159 3.70479 3.11737C12.6062 11.977 21.4998 20.8444 30.3943 29.7105C30.4572 29.7729 30.511 29.8446 30.4981 29.8289C20.8114 39.5161 11.1371 49.1904 1.43983 58.8872Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.95648 0.536377C16.7134 7.11129 28.4708 13.6857 40.169 20.2276C37.5128 22.949 34.8988 25.6268 32.1907 28.4006C22.9682 19.2039 13.7105 10.1326 4.73926 0.776101C4.81182 0.695734 4.88392 0.615825 4.95648 0.536377Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.0728 31.5679C34.8223 34.3045 37.4937 36.963 40.2266 39.6831C28.4664 46.2584 16.6966 52.8393 4.9268 59.4207C4.86526 59.3394 4.80373 59.2581 4.74219 59.1768C13.6937 49.7946 23.0056 40.7682 32.0728 31.5679Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.3393 21.4421C44.7935 22.8281 47.267 24.2095 49.7243 25.6198C50.7498 26.2081 51.7505 26.8423 52.7438 27.4843C53.1351 27.7374 53.5011 28.0414 53.8354 28.367C54.8692 29.3746 54.8673 30.592 53.8184 31.6009C53.4345 31.9706 53.0139 32.3219 52.5565 32.5906C49.1512 34.591 45.7326 36.569 42.3972 38.5079C39.4916 35.6096 36.6498 32.7752 33.877 30.0097C36.6654 27.1867 39.4856 24.3317 42.3393 21.4421Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup82);
export default __webpack_public_path__ + "static/media/Group 82.d12e5171.svg";
export { ForwardRef as ReactComponent };